import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyD7bv-x9cb4Dw90PPk8jGchL0-miIVyxSI",
  authDomain: "graphical-fort-386720.firebaseapp.com",
  projectId: "graphical-fort-386720",
  storageBucket: "graphical-fort-386720.appspot.com",
  messagingSenderId: "501754523103",
  appId: "1:501754523103:web:bb7e40aa6100383941686a",
  measurementId: "G-17PJB7W3BR"
};

const app = initializeApp(firebaseConfig);

// 👉 Safe check environment
export const isSupported = () =>
  typeof window !== "undefined" &&
  "Notification" in window &&
  "serviceWorker" in navigator &&
  "PushManager" in window;

// 👉 Lazy init, tránh crash
let messaging = null;
try {
  if (isSupported()) {
    messaging = getMessaging(app);
  }
} catch (e) {
  console.warn("⚠️ Firebase messaging not supported:", e);
}

export const requestForToken = async () => {
  if (!messaging) return null;
  try {
    const currentToken = await getToken(messaging, {
      vapidKey:
        "BPvjIsd9ZRSPG_-sg2eY-jCO6rrUlskz53Cp-ow48Y_lLSKMwPCU5sCvkpFsMe_-3iehIA-w920Yn4lyOyyVcdA",
    });
    return currentToken || null;
  } catch (err) {
    console.error("getToken error", err);
    return null;
  }
};

export const requestPermission = () => {
  if (!messaging || !isSupported()) {
    console.log("Notifications not supported in this env");
    return;
  }
  Notification.requestPermission().then((permission) => {
    if (permission === "granted") {
      getToken(messaging, {
        vapidKey:
          "BPvjIsd9ZRSPG_-sg2eY-jCO6rrUlskz53Cp-ow48Y_lLSKMwPCU5sCvkpFsMe_-3iehIA-w920Yn4lyOyyVcdA",
      })
        .then((currentToken) => {
          if (currentToken) {
            console.log("Got token:", currentToken);
          }
        })
        .catch((err) => {
          console.error("Token error", err);
        });
    } else {
      console.log("Notification Permission Not Given");
    }
  });
};

export const onMessageListener = () =>
  new Promise((resolve) => {
    if (!messaging) {
      console.warn("Messaging not available");
      return;
    }
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });

export { app, messaging };
